import {useEffect, useState} from 'react';
import {FormControl, MenuItem, TextField, Grid} from '@mui/material';

const CommunicationInterfaceEditComponent = ({
                                                 communicationInterface,
                                                 electricalInterfaceTypeOptions,
                                                 modbusEncodingOptions,
                                                 byteOrderOptions,
                                                 adcMeasurementTypeOptions,
                                                 validationErrors,
                                                 setValidationErrors,
                                                 row,
                                                 communicationInterfaceTypeOptions
                                             }) => {
    const [communicationInterfaceType, setCommunicationInterfaceType] = useState(communicationInterface?.type);
    const [fieldValues, setFieldValues] = useState(communicationInterface);

    const handleTypeChange = (event) => {
        setCommunicationInterfaceType(event.target.value);
        setFieldValues({type: event.target.value});
    };

    const handleChange = (event) => {
        setFieldValues({
            ...fieldValues,
            [event.target.name]: event.target.value,
        });
    };

    useEffect(() => {
        row._valuesCache.communicationInterface = fieldValues;
    }, [fieldValues]);

    const renderModbusFields = () => (
        <>
            <TextField
                select
                fullWidth
                margin="normal"
                variant="standard"
                label="Electrical Interface Type"
                name="electricalInterfaceType"
                value={fieldValues.electricalInterfaceType || ''}
                onChange={handleChange}
            >
                {electricalInterfaceTypeOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                fullWidth
                margin="normal"
                variant="standard"
                label="Name"
                name="name"
                value={fieldValues.name || ''}
                onChange={handleChange}
            />
            <TextField
                fullWidth
                margin="normal"
                variant="standard"
                label="Label"
                name="label"
                value={fieldValues.label || ''}
                onChange={handleChange}
            />
                <TextField
                    fullWidth
                    margin="normal"
                    select
                    id="byte-order"
                    variant="standard"
                    name="byteOrder"
                    value={fieldValues.byteOrder || ''}
                    label="Byte Order"
                    onChange={handleChange}
                >
                    {byteOrderOptions.map(option => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
            <TextField
                select
                fullWidth
                variant="standard"
                margin="normal"
                label="Modbus Encoding"
                name="modbusEncoding"
                value={fieldValues.modbusEncoding || ''}
                onChange={handleChange}
            >
                {modbusEncodingOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </TextField>
        </>
    );

    const renderAnalogOrDigitalFields = () => (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        variant="standard"
                        label="Electrical Interface Type"
                        name="electricalInterfaceType"
                        value={fieldValues.electricalInterfaceType || ''}
                        onChange={handleChange}
                        error={!!validationErrors?.['communicationInterface.electricalInterfaceType']}
                        helperText={validationErrors?.['communicationInterface.electricalInterfaceType']}
                        required={true}
                        onFocus={() =>
                            setValidationErrors({
                                ...validationErrors,
                                ['communicationInterface.electricalInterfaceType']: undefined,
                            })}
                    >
                        {electricalInterfaceTypeOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
            </Grid>
        </>
    );

    const renderAdcFields = () => (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        variant="standard"
                        label="Electrical Interface Type"
                        name="electricalInterfaceType"
                        value={fieldValues.electricalInterfaceType || ''}
                        onChange={handleChange}
                        error={!!validationErrors?.['communicationInterface.electricalInterfaceType']}
                        helperText={validationErrors?.['communicationInterface.electricalInterfaceType']}
                        required={true}
                        onFocus={() =>
                            setValidationErrors({
                                ...validationErrors,
                                ['communicationInterface.electricalInterfaceType']: undefined,
                            })}
                    >
                        {electricalInterfaceTypeOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        select
                        fullWidth
                        margin="normal"
                        variant="standard"
                        label="ADC Measurement Type"
                        name="adcMeasurementType"
                        value={fieldValues.adcMeasurementType || ''}
                        onChange={handleChange}
                        error={!!validationErrors?.['communicationInterface.adcMeasurementType']}
                        helperText={validationErrors?.['communicationInterface.adcMeasurementType']}
                        required={true}
                        onFocus={() =>
                            setValidationErrors({
                                ...validationErrors,
                                ['communicationInterface.adcMeasurementType']: undefined,
                            })}
                    >
                        {adcMeasurementTypeOptions.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        fullWidth
                        margin="normal"
                        variant="standard"
                        label="Min Value"
                        name="minValue"
                        type="number"
                        value={fieldValues.minValue || ''}
                        onChange={handleChange}
                        error={!!validationErrors?.['communicationInterface.minValue']}
                        helperText={validationErrors?.['communicationInterface.minValue']}
                        required={true}
                        onFocus={() =>
                            setValidationErrors({
                                ...validationErrors,
                                ['communicationInterface.minValue']: undefined,
                            })}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <TextField
                        fullWidth
                        margin="normal"
                        label="Max Value"
                        variant="standard"
                        name="maxValue"
                        type="number"
                        value={fieldValues.maxValue || ''}
                        onChange={handleChange}
                        error={!!validationErrors?.['communicationInterface.maxValue']}
                        helperText={validationErrors?.['communicationInterface.maxValue']}
                        required={true}
                        onFocus={() =>
                            setValidationErrors({
                                ...validationErrors,
                                ['communicationInterface.maxValue']: undefined,
                            })}
                    />
                </Grid>
            </Grid>
        </>
    );

    const renderFieldsBasedOnType = () => {
        switch (communicationInterfaceType) {
            //TODO: Uncomment when modbus is implemented
            // case 'modbus':
            //     return renderModbusFields();
            case 'analog':
            case 'digital':
                return renderAnalogOrDigitalFields();
            case 'adc':
                return renderAdcFields();
            default:
                return null;
        }
    };

    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6} md={3}>
                    <FormControl fullWidth margin="dense">
                        <TextField
                            select
                            id="interface-type"
                            variant="standard"
                            value={communicationInterfaceType}
                            label="Interface Type"
                            onChange={handleTypeChange}
                            error={!!validationErrors?.communicationInterface}
                            helperText={validationErrors?.communicationInterface}
                            required={true}
                            onFocus={() =>
                                setValidationErrors({
                                    ...validationErrors,
                                    communicationInterface: undefined,
                                })}
                        >
                            {communicationInterfaceTypeOptions.map(option => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </FormControl>
                </Grid>
            </Grid>
            {renderFieldsBasedOnType()}
        </>
    );
};

export default CommunicationInterfaceEditComponent;
